/*************
 * findARetailer
 * Form controller for Find A Retailer form.
 * Assures form is valid, then submits a standard submission
 * to IBM Watson. The IBM Watson needs to have its submit
 * redirection handled within its admin.
 *
 * We store in local storage because of SilverPop AJAX limitations.
 * By caching the current URL the user submitted from, we can then
 * redirect from the thank you page accordingly.
 *
 */
import SENTRY from '../custom/sentry.js';
// Requires magnific to run
require('magnific-popup');
// Google Tag Manager DataLayer Helper
require('custom/gtm-datalayer');

custom.simpleFormHandler = (() => {
  const ids = [
    'find-a-retailer-form',
    'request-access-form',
    'request-a-catalog-form',
    'waitlist-form',
    'contact-form',
  ];

  const $emailInputField = $('#control_EMAIL'); // Email input field

  const initializedClass = 'mfp-initialized';

  // Simple Form General Classes
  const simpleFormClassName = 'js-simple-form';
  const responseMsgClass = `${simpleFormClassName}-response`;
  const errorMsgClass = `${simpleFormClassName}-error`;

  // Find A Retailer related Static Values
  const farClassName = 'js-find-a-retailer-form';
  const retailerErrorMsg = 'An error occured.';

  // Waitlist Elements
  const $nonCustomerWaitlistForm = $('.js-waitlist-form');
  const customerWaitListClass = 'js-waitlist-form--customer';

  // Contact Form Elements
  const contactClassName = 'js-contact-form';
  const $contactInquirySelect = $('#inquiry');

  // Request Catalog Form Elements
  const requestCatalogClassName = 'js-request-a-catalog-form';

  // Recaptcha forms
  const recaptchaClassName = 'js-simple-form--has-recaptcha';

  function openCustomerConfirmation(form = null) {
    const $submit = $(form).find("[type='submit']");

    $.magnificPopup.open({
      items: {
        src: $('.js-waitlist-customer-form-container'),
      },
      type: 'inline',
      // Delay in milliseconds before popup is removed
      removalDelay: 600,

      // Class that is added to popup wrapper and background
      // make it unique to apply your CSS animations just to this exact popup
      mainClass: 'mfp-fade',
      callbacks: {
        beforeOpen: function () {
          $submit.addClass(initializedClass).blur();
          $('.js-waitlist-customer-trigger')
            .prop('disabled', true)
            .val('Waitlisted');
        },
      },
    });
  }

  /******************
   * FORM SUBMISSION
   */
  function formSubmission(form = null) {
    //submit button loader state
    var $submit = $(form).find("[type='submit']");
    custom.utils.submitLoaderHandler($submit);

    //build the payload for hubspot depending on the form type
    if (
      ($(form).hasClass(farClassName) ||
        $(form).hasClass(contactClassName) ||
        $(form).hasClass(requestCatalogClassName)) &&
      $(form).data('form') !== undefined
    ) {
      let fields = [];
      if ($(form).hasClass(farClassName)) {
        fields = [
          {
            objectTypeId: '0-1', //contact
            name: 'email',
            value: $(form).find('input[name="Email"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'zip',
            value: $(form).find('input[name="Zip Code"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'form_request_product_name',
            value: $(form).find('input[name="Product Name"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'form_request_collection_name',
            value: $(form).find('input[name="Collection Name"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'form_request_brand',
            value: $(form).find('input[name="Collaboration Name"]').val() || '',
          },
        ];
      } else if ($(form).hasClass(contactClassName)) {
        fields = [
          {
            objectTypeId: '0-1', //contact
            name: 'firstname',
            value: $(form).find('input[name="First Name"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'lastname',
            value: $(form).find('input[name="Last Name"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'email',
            value: $(form).find('input[name="email_address"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'company',
            value: $(form).find('input[name="company"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'phone',
            value: $(form).find('input[name="phone"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'inquiry',
            value: $(form).find('select[name="inquiry"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'city',
            value: $(form).find('input[name="city"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'state',
            value: $(form).find('select[name="state"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'message',
            value: $(form).find('textarea[name="message"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'how_did_you_hear',
            value: $(form).find('select[name="howDidYouHear"]').val() || '',
          },
        ];
      } else if ($(form).hasClass(requestCatalogClassName)) {
        let stateField = '';
        const country = $(form).find('select[name="Country"]').val();
        switch (country) {
          case 'United States':
            stateField = 'state';
            break;
          case 'Canada':
            stateField = 'canada_province_territory';
            break;
          case 'Mexico':
            stateField = 'mexico_state';
            break;
        }
        fields = [
          {
            objectTypeId: '0-1', //contact
            name: 'firstname',
            value: $(form).find('input[name="First Name"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'lastname',
            value: $(form).find('input[name="Last Name"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'email',
            value: $(form).find('input[name="Email"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'phone',
            value: $(form).find('input[name="Phone Number"]').val() || '',
          },
          {
            objectTypeId: '0-2', //company
            name: 'name',
            value: $(form).find('input[name="Company"]').val() || '',
          },
          {
            objectTypeId: '0-2', //company
            name: 'domain',
            value: $(form).find('input[name="Website"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'address',
            value: $(form).find('input[name="Address"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'address_2',
            value: $(form).find('input[name="Apt No"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'city',
            value: $(form).find('input[name="City"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'country',
            value: country || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: stateField,
            value: $(form).find('select[name="State"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'zip',
            value: $(form).find('input[name="Zip Code"]').val() || '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'loloi_account_number',
            value: $(form).find('input[name="Loloi Account #"]').val() || '',
          },
          {
            objectTypeId: '0-2', //company
            name: 'primary_type_of_business',
            value:
              $(form).find('.js-bad-business-type:checked').val() !== undefined
                ? $(form).find('.js-bad-business-type:checked').val()
                : '',
          },
          {
            objectTypeId: '0-2', //company
            name: 'secondary_type_of_business',
            value: $(form)
              .find('input[name="Secondary Type Of Business[]"]:checked')
              .map(function () {
                return this.value;
              })
              .get()
              .join(';'),
          },
          {
            objectTypeId: '0-2', //company
            name: 'rug_rack',
            value:
              $(form).find('input[name="Rug Rack"]:checked').val() != undefined
                ? $(form).find('input[name="Rug Rack"]:checked').val()
                : '',
          },
        ];
      }
      const hutk = custom.utils.getCookie('hubspotutk');
      const postForm = $(form).data('form');
      let sendData = {
        submittedAt: new Date().getTime(),
        fields: fields,
        context: {
          ...(hutk ? { hutk: hutk } : {}),
          pageUri: window.location.host + window.location.pathname,
          pageName: document.title,
        },
      };
      window.MUAPP.sendCRMForm(postForm, sendData).then(
        (data) => {
          showResponseMessage($(form), true);
          if ($(form).hasClass(recaptchaClassName)) {
            $(form).find('.g-recaptcha').fadeOut(300);
          }
          
          custom.gtmDatalayer.gtmPushElem($(form));
        },
        (err) => {
          custom.utils.removeSubmitLoaderHandler($submit);
          custom.utils.sendCustomSentryError(
            `Submit form to Hubspot failed`,
            {
              extra: {error: err, pageUri: window.location.host + window.location.pathname},
              tags: {module: 'Shopify API', category: SENTRY.CATEGORIES.FORM},
            },
          );
        },
      );
    } else {
      // old basin forms
      $.ajax({
        type: 'POST',
        url: $(form).attr('action'),
        crossDomain: true,
        data: $(form).serialize(),
        dataType: 'json',
        headers: {
          Accept: 'application/json',
        },
        success: function (response) {
          if ($(form).hasClass(customerWaitListClass)) {
            openCustomerConfirmation(form);
          } else {
            if ($(form).hasClass('highpoint-form')) {
              const formHeight = $(form).height();
              const formWidth = $(form).width();

              highpointResponseHandler(
                $(form),
                response.success,
                formHeight,
                formWidth,
              );
            } else {
              showResponseMessage($(form), response.success);
            }
          }
          if ($(form).hasClass(recaptchaClassName)) {
            $(form).find('.g-recaptcha').fadeOut(300);
          }
          custom.gtmDatalayer.gtmPushElem($(form));
        },
        error: function (response) {
           custom.utils.sendCustomSentryError(
            `Submit UseBasin Form failed`,
            {
              extra: {error: response, pageUri: window.location.host + window.location.pathname},
              tags: {module: 'Simple Form Handler', category: SENTRY.CATEGORIES.FORM},
            },
          );
          custom.utils.removeSubmitLoaderHandler($submit);
        },
      });
    }
  }

  /******************
   * FORM HANDLER
   */
  function formSubmissionHandler(form = null) {
    let submit = true;
    if ($(form).hasClass(customerWaitListClass)) {
      if (localStorage.getItem('waitlistSubmitted')) {
        submit = false;
        openCustomerConfirmation(form);
      } else {
        localStorage.setItem('waitlistSubmitted', true);
      }
    }
    if ($(form).hasClass(recaptchaClassName)) {
      const response = grecaptcha.getResponse();
      $(form).find(`.${errorMsgClass}`).addClass('hidden').text('');
      if (response.length == 0) {
        $(form)
          .find(`.${errorMsgClass}`)
          .removeClass('hidden')
          .text('Recaptcha failed.');
        submit = false;
      }
    }

    if (submit) formSubmission(form);
  }

  /******************
   * FORM VALIDATION HANDLING
   */
  function formValidationHandler(id) {
    // const $forms = $(`.js-${id}`); // Form modal
    const $forms = $('.js-' + id);

    // Run parsley validations
    if ($forms.length) {
      $forms.each(function (index, form) {
        $(form)
          .parsley(custom.utils.parsleyOption())
          .on('form:submit', function (data) {
            formSubmissionHandler(form);
            return false;
          });
      });
    }
  }

  /******************
   * EMAIL INPUT FIELD HANDLING
   */

  // Email to lowecase handler
  // This helps with backend validation on Watson
  // since it doesn't like capitalization
  function lowerCaseHandler() {
    const currValue = $(this).val();
    $(this).val(currValue.toLowerCase());
  }

  // Bind the email handler
  $emailInputField.on('keyup', lowerCaseHandler);

  /******************
   * MODAL TRIGGER BINDINGS
   */

  // Bind the magnific popup handler to the trigger
  function inputPopupHandler(id) {
    const $trigger = $(`.js-${id}-trigger`);

    if ($trigger.length > 0 && !$trigger.hasClass(initializedClass)) {
      $trigger.magnificPopup({
        type: 'inline',
        // Delay in milliseconds before popup is removed
        removalDelay: 600,

        // Class that is added to popup wrapper and background
        // make it unique to apply your CSS animations just to this exact popup
        mainClass: 'mfp-fade',
        callbacks: {
          beforeOpen: function () {
            $trigger.addClass(initializedClass).blur();
          },
        },
      });
    }
  }

  function highpointResponseHandler(
    form = null,
    isSuccess = true,
    height,
    width,
  ) {
    let successMsg = `<h3 class="rtype-title-large mb-4">Thank You.</h3> <p>You've successfully subscribed.</p>`;
    if ($(form).hasClass('appointment')) {
      successMsg = `<h3 class="rtype-title-large mb-4">Thank You.</h3> <p>Your local Loloi sales rep will be in touch to schedule your appointment.</p>`;
    }
    if ($(form).hasClass('virtual-appointment')) {
      successMsg = `<h3 class="rtype-title-large mb-4">See You Soon.</h3> <p>Thank you. We'll be in touch to schedule your appointment.</p>`;
    }
    let msg;
    if (isSuccess) {
      msg = successMsg;
    } else {
      msg = retailerErrorMsg;
    }
    function isMobile() {
      return $(window).width() < 768;
    }
    $(form).height(height);
    $(form).width(width);
    $(form).html(msg);

    if (isMobile()) {
      $('.mfp-wrap').animate({ scrollTop: 0 }, 'fast', 'linear');
    }
  }

  /******************
   * showResponseMessage
   */
  function showResponseMessage(form = null, isSuccess = true) {
    const $submit = $(form).find("[type='submit']");
    const waitlistFormClass = 'waitlist-form';

    const retailerSuccessMsg =
      $(form).hasClass('request-a-catalog-form') ||
      $(form).hasClass('request-access-form') ||
      $(form).hasClass(contactClassName)
        ? "Thanks, we'll be in touch soon."
        : 'We’ll email you a list of local retailers soon.';

    const waitlistSuccessMsg = $(form).hasClass(waitlistFormClass)
      ? "Thanks! We'll email you on September 10th when wall art is available to order."
      : '';

    const msgClass = isSuccess ? responseMsgClass : errorMsgClass;
    // const msg = (isSuccess)? retailerSuccessMsg : retailerErrorMsg;
    let msg = '';

    if (isSuccess) {
      msg = $(form).hasClass(waitlistFormClass)
        ? waitlistSuccessMsg
        : retailerSuccessMsg;
    } else {
      msg = retailerErrorMsg;
    }

    $(form).find(`.${msgClass}`).removeClass('hidden').text(msg);

    // $submit.prop( "disabled", true );

    if ($(form).hasClass(waitlistFormClass)) {
      if ($(form).hasClass(customerWaitListClass)) return;
      $submit.hide();
    } else if ($(form).hasClass('request-a-catalog-form')) {
      $(form).find("[type='submit']").addClass('hidden');
    } else if ($(form).hasClass(farClassName)) {
      $submit.hide();
      // $(form).find(".custom-input").hide();
    } else if ($(form).hasClass(contactClassName)) {
      $submit.hide();
    } else {
      setTimeout(() => {
        $(form).find(`.${msgClass}`).addClass('hidden').text('');
      }, 5000);
    }
  }

  function initWaitlistValidationHandler(form) {
    const $submit = $(form).find("[type='submit']");
    const $inputs = $(form).find("[type='email'], [type='text']");

    $(form).parsley();

    $inputs.each((index, input) => {
      // Keyup event to handle toggle of disabled submit button
      $(input).on('keyup', () => {
        if ($(form).parsley().isValid()) {
          $submit.prop('disabled', false);
        } else {
          $submit.prop('disabled', true);
        }
      });

      // Blur event for email field validation
      $(input).on('blur', () => {
        const group = $(input).data('parsley-group');

        if (group == 'email') $(form).parsley().validate({ group });
      });
    });
  }

  // if contact form inquiry type is Sales, then show city and state fields
  function contactInquirySelectHandler(event = null) {
    const inquiryType = $(event.target).val();
    switch (inquiryType) {
      case 'Sales Inquiry':
        custom.utils.enableOption('.js-contact-city');
        custom.utils.enableOption('.js-contact-state');
        break;
      default:
        custom.utils.disableOption('.js-contact-city');
        custom.utils.disableOption('.js-contact-state');
    }
  }

  function init() {
    ids.forEach((id) => {
      formValidationHandler(id);
      inputPopupHandler(id);
    });

    if ($contactInquirySelect.length > 0) {
      custom.utils.disableOption('.js-contact-city');
      custom.utils.disableOption('.js-contact-state');
      $contactInquirySelect.on('change', contactInquirySelectHandler);
    }

    if ($nonCustomerWaitlistForm.length > 0) {
      initWaitlistValidationHandler($nonCustomerWaitlistForm);
    }
  }

  return {
    formSubmission,
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/simple-form-handler.js